var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-autocomplete',{attrs:{"componentRestrictions":{country: _vm.country},"placeholder":_vm.placeholder,"value":_vm.getValue,"types":_vm.types},on:{"place_changed":_vm.getAddressData,"input":_vm.changeInputValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }